import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { Card } from "../components/ui/card";
import { Input } from "../components/ui/input";
import { Button } from "../components/ui/button";
import { Zap } from "lucide-react";

export default function AdminLoginPage() {
  const { user, login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  if (user && user !== false && user !== null) {
    return <Navigate to="/admin" replace />;
  }

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    const r = await login(email, password);
    setLoading(false);
    if (r.ok) navigate("/admin");
    else setError(r.error);
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-4">
      <Card className="w-full max-w-md bg-card border-black/10 rounded-2xl p-8">
        <div className="flex items-center gap-2 mb-6">
          <div className="h-10 w-10 rounded-md bg-primary flex items-center justify-center bolt-glow"><Zap className="h-5 w-5 text-black" strokeWidth={3} /></div>
          <div>
            <div className="font-display font-black text-lg">Admin Login</div>
            <div className="text-xs uppercase tracking-[0.24em] text-secondary">Bharat Battery House</div>
          </div>
        </div>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="text-xs uppercase tracking-[0.2em] font-bold text-muted-foreground">Email</label>
            <Input data-testid="admin-login-email" type="email" value={email} onChange={e => setEmail(e.target.value)} required className="mt-2 h-12 bg-muted/40 border-black/10" />
          </div>
          <div>
            <label className="text-xs uppercase tracking-[0.2em] font-bold text-muted-foreground">Password</label>
            <Input data-testid="admin-login-password" type="password" value={password} onChange={e => setPassword(e.target.value)} required className="mt-2 h-12 bg-muted/40 border-black/10" />
          </div>
          {error && <div className="text-sm text-destructive" data-testid="admin-login-error">{error}</div>}
          <Button data-testid="admin-login-submit" type="submit" disabled={loading} className="w-full rounded-full bg-primary text-black hover:bg-secondary hover:text-white h-12 font-semibold">
            {loading ? "Signing in…" : "Sign In"}
          </Button>
        </form>
      </Card>
    </div>
  );
}
